import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import RoleRestrictedRoute from 'utility/routing/RoleRestrictedRoute';
import { roles } from 'utility/constants/roles';

const ProjectDashboard = lazy(() => import('pages/projects/ProjectDashboard'));

const ProjectCreate = lazy(() => import('pages/projects/ProjectCreate'));
const ProjectList = lazy(() => import('pages/projects/ProjectList'));

const NotFound = lazy(() => import('pages/NotFound'));

const ProjectsRouter = () => {
	return (
		<Switch>
			<RoleRestrictedRoute
				exact
				path="/projects"
				component={ProjectList}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/projects/dashboard/:projectId"
				component={ProjectDashboard}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/projects/create"
				component={ProjectCreate}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<Route>
				<NotFound />
			</Route>
		</Switch>
	);
};

export default ProjectsRouter;
